import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { CrmLeadStatus } from "@enums/crmLeadStatus.enum";
import { GetPropertiesFromEnum } from "@helpers/getPropertiesFromEnum";
import { AdminHeaderButton } from "@interfaces/adminHeaderButton.interface";
import { LogExport } from "@interfaces/logExport.interface";
import { CrmLeadService } from "@services/crmLead.service";
import { ExportLogService } from "@services/exportLog.service";
import { ProtectedGridService } from "@services/protectedGrid.service";
import { ToastService } from "angular-toastify";

@Component({
	moduleId: module.id,
	selector: "crm-leads",
	styleUrls: ["crmLeads.css"],
	templateUrl: "crmLeads.html"
})
export class CrmLeadsAdminComponent {
	allItems: any[] = [];
	canExportGrid = false;
	deleteEnabled = true;
	editEnabled = true;
	gridLoading = false;
	headerPrimaryButtons: AdminHeaderButton[] = [];
	itemType = "CRM Lead";
	itemUrl: string = location.href.split("/")[3] + "/" + location.href.split("/")[4];
	items: any[] = [];
	showInactive = false;
	statuses: any;

	constructor(private router: Router, private toastService: ToastService, private itemService: CrmLeadService, private exportLogService: ExportLogService, private protectedGridService: ProtectedGridService) {
		this.headerPrimaryButtons.push({ icon: "fal fa-plus", method: "addNewItem", text: `New ${this.itemType}` });
		this.headerPrimaryButtons.push({ icon: "fal fa-eye-slash", method: "toggleShowInactive", text: "Show Inactive" });
		this.statuses = GetPropertiesFromEnum(CrmLeadStatus);
		this.viewRow = this.viewRow.bind(this);
		this.editRow = this.editRow.bind(this);
		this.deleteRow = this.deleteRow.bind(this);
		this.getLeadStateLabel = this.getLeadStateLabel.bind(this);
		this.toggleActiveRow = this.toggleActiveRow.bind(this);
		this.getItems();
		this.checkGridExportPermissions();
	}

	addNewItem() {
		this.router.navigate([`${this.itemUrl}/create`]);
	}

	checkGridExportPermissions() {
		this.protectedGridService.canExport("CrmLeads")
			.subscribe(
				(res: any) => { this.canExportGrid = res.response; },
				(err) => { console.log(err); }
			);
	}

	deleteRow(e: any) {
		const result = confirm("Are you sure you want to delete this lead?");
		if (result) {
			this.itemService.deleteSingleById(e.row.data.id)
				.subscribe(
					() => { this.toastService.success("Lead deleted!"); this.getItems(); },
					(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
				);
		}
	}

	editRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}_edit`]);
	}

	filterItems() {
		this.items = this.showInactive ? this.allItems : this.allItems.filter((l: any) => l.isActive);
	}

	getItems() {
		this.gridLoading = true;
		this.itemService.getAll()
			.subscribe(
				(res: any) => { this.allItems = res.response.items; this.filterItems(); this.gridLoading = false; },
				(err) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
			);
	}

	getLeadStateLabel(item: any): string {
		if (!item?.isActive) return "Inactive";
		return item.clientId ? "Active Customer" : "Active Lead";
	}

	headerButtonClick(method: any) {
		// @ts-ignore
		if (this[method]) this[method]();
	}

	logExport() {
		const logExport = new LogExport();
		logExport.gridName = "CrmLeads";
		this.exportLogService.logExport(logExport).subscribe();
	}

	toggleActiveRow(e: any) {
		this.itemService.toggleActive(e.row.data.id).subscribe(
			() => { this.getItems(); },
			(err: any) => { console.log(err); this.toastService.error("Something Went Wrong!"); }
		);
	}

	toggleShowInactive() {
		this.showInactive = !this.showInactive;
		this.headerPrimaryButtons = this.headerPrimaryButtons.map(b =>
			b.method === "toggleShowInactive"
				? { ...b, icon: this.showInactive ? "fal fa-eye" : "fal fa-eye-slash", text: this.showInactive ? "Hide Inactive" : "Show Inactive" }
				: b
		);
		this.filterItems();
	}

	viewRow(e: any) {
		this.router.navigate([`${this.itemUrl}/${e.row.data.id}`]);
	}
}
